import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import SearchBar from "material-ui-search-bar";


function descendingComparator(a, b, orderBy) {
    if (a[orderBy] === null) {
        return 1;
    }
    else if (b[orderBy] === null) {
        return -1;
    }
    if (orderBy === 'displayPoolName' || orderBy === 'displayPoolDescription') {
        return a[orderBy].toLowerCase().localeCompare(b[orderBy].toLowerCase());
    }
    else if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    else if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
const headCells = [
    { id: 'poolId', label: 'Pool ID' },
    { id: 'changedDate', label: 'Date' },
    { id: 'displayPoolName', label: 'Pool Name' },
    { id: 'displayPoolDescription', label: 'Pool Description' },
    { id: 'displayAction', label: 'Action' },
    { id: 'changedBy', label: 'Changed By' }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, handleSearch, handleCancelSearch } = props;

    const [searchedName, setSearchedName] = useState("");
    const [searchedDescription, setSearchedDescription] = useState("");
    const [searchedAction, setSearchedAction] = useState("Action");

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const searchHandler = (searchVal, domain) => {
        handleSearch(searchVal, domain);
        if (domain == 'displayPoolName') {
            setSearchedDescription('');
            setSearchedAction(' Action ');
            setSearchedName(searchVal);
        }
        if (domain == 'displayPoolDescription') {
            setSearchedName('');
            setSearchedAction(' Action ');
            setSearchedDescription(searchVal);
        }
        if (domain == 'displayAction') {
            setSearchedName('');
            setSearchedDescription('');
            setSearchedAction(searchVal)
        }
    }
    return (
        <TableHead>
            <TableRow>
                <TableCell />
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='center'
                        paddingBottom='50px'
                        style={{ fontSize: '1vw', padding: '5px' }}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <div class="input-group" style={{ justifyContent: 'center', marginBottom: '8px', minWidth: '197px' }}>
                            {headCell.id === "displayPoolName" &&

                                <SearchBar
                                    placeholder="Pool Name"
                                    value={searchedName}
                                    onChange={(searchVal) => searchHandler(searchVal, "displayPoolName")}
                                    onCancelSearch={() => handleCancelSearch()}
                                    className={classes.searchbar}
                                    style={{ width: '80%' }}
                                />
                            }
                            {headCell.id === "displayPoolDescription" &&

                                <SearchBar
                                    placeholder="Pool Description"
                                    value={searchedDescription}
                                    onChange={(searchVal) => searchHandler(searchVal, "displayPoolDescription")}
                                    onCancelSearch={() => handleCancelSearch()}
                                    className={classes.searchbar}
                                    style={{ width: '80%' }}
                                />
                            }

                            {headCell.id != "displayAction" &&
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={createSortHandler(headCell.id)}
                                >
                                    {(headCell.id == "changedBy" || headCell.id == "poolId" || headCell.id == "changedDate") &&
                                        <div align='center' style={{ fontSize: '.9vw' }} >
                                            {headCell.label}
                                        </div>
                                    }
                                    {orderBy === headCell.id ? (
                                        <span className={classes.visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </span>
                                    ) : null}
                                </TableSortLabel>
                            }
                        </div>

                        {headCell.id === "displayAction" &&
                            <select value={searchedAction} class="form-control" type="text" name="displayAction"
                                style={{ width: '125px', height: '40px', fontSize: '.75vw', margin: 'auto', marginBottom: '12px' }}
                                onChange={(v) => searchHandler(v.target.value.toString(), "displayAction")}>
                                <option value="" > Action </option>
                                <option value="Insert">Insert</option>
                                <option value="Update">Update</option>
                                <option value="Delete">Delete</option>
                            </select>
                        }

                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    title: {
        flex: '1 1 100%'
    }
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;
    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0
            })}
        >
            <Typography className={classes.title} variant="h5" id="tableTitle" component="div">
                Pool Audit
            </Typography>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    },
    searchbar: {
        width: '200px',
        height: '40px'
    },
    firstCell: {
        width: '10%',
        minWidth: '20px'
    },
    bigCell: {
        width: '10px',
        heigth: '50px',
        minWidth: '20px',
        maxWidth: '10px',
        align: 'center',
        position: 'absolute',
        wordWrap: 'break-word'
    },
    subTable: {
        "& td": {
            width: '33%',
            borderLeft: '1px solid rgba(224, 224, 224, 1)'
        }
    }
}));

const getDateFormat = (date) => {
    if (date == null) return
    var newDate = date.split('T')[0];
    var dateArray = newDate.split('-');
    var year = dateArray[0].substring(2);
    var month = dateArray[1];
    var day = dateArray[2];
    var fullTime = date.split('T')[1].split('.')[0];
    var hour = fullTime.substring(0, 2);
    var finalTime;
    if (parseInt(hour) > 12) {
        if (parseInt(hour) > 21) {
            finalTime = (hour - 12) + fullTime.substring(2, 5);
        } else {
            finalTime = "0" + (hour - 12) + fullTime.substring(2, 5);
        }
        finalTime += " PM"
    } else {
        finalTime = hour + fullTime.substring(2, 5);
        finalTime += " AM"
    }
    var myDate = `${month}/${day}/${year} - ${finalTime}`
    return myDate;
}


function CollapsedRows(props) {
    const { row, index, classes } = props;
    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <TableRow style={{ backgroundColor: index % 2 ? "#f8f8f8" : "white", height: '80px' }}>
                <TableCell class="firstCell" >
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell style={{ borderBottom: 'none' }} align="center">{row.poolId}</TableCell>
                <TableCell style={{ borderBottom: 'none' }} align="left">{getDateFormat(row.changedDate)}</TableCell>
                <TableCell style={{ borderBottom: 'none' }} align="center">{row.displayPoolName}</TableCell>
                <TableCell style={{ borderBottom: 'none' }} align="center">{row.displayPoolDescription}</TableCell>
                <TableCell style={{ borderBottom: 'none' }} align="center">{row.displayAction}</TableCell>
                <TableCell style={{ borderBottom: 'none' }} align="center">{row.changedByName == null ? row.changedBy : row.changedByName}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Change Made
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Details</TableCell>
                                        <TableCell>Before</TableCell>
                                        <TableCell>After</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.subTable}>
                                    <TableRow style={{ background: '#F8F8F8' }}>
                                        <TableCell style={{ borderLeft: 'none' }}>Pool Name</TableCell>
                                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }}>{row.poolName}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.poolName!= null && row.poolName != row.newPoolName ? 'bold' : 'normal'
                                            }}>
                                            {row.newPoolName}
                                        </TableCell>
                                    </TableRow> 
                                    <TableRow>
                                        <TableCell style={{ borderLeft: 'none' }}>Pool Description</TableCell>
                                        <TableCell>{row.poolDescription}</TableCell>
                                        <TableCell
                                            style={{
                                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: row.poolDescription != null && row.poolDescription != row.newPoolDescription ? 'bold' : 'normal'
                                            }}>
                                            {row.newPoolDescription}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
const PoolAuditTable = ({ data: poolAudits }) => {
    const classes = useStyles();
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('changedDate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searched, setSearched] = useState("");
    console.log(poolAudits);
    const getPools = () => {
        return poolAudits.map(pool => {
            if (pool.action == 'Delete') {
                return {
                    id: pool.id,
                    poolId: pool.poolId,
                    displayPoolName: pool.poolName,
                    displayPoolDescription: pool.poolDescription,
                    displayAction: pool.action,
                    poolName: pool.poolName,
                    poolDescription: pool.poolDescription,
                    changedDate: pool.changedDate,
                    action: pool.action,
                    changedBy: pool.changedBy,
                    newPoolName: pool.newPoolName,
                    newPoolDescription: pool.newPoolDescription,
                    healthy: pool.healthy,
                    newHealthy: pool.newHealthy,
                    changedByName: pool.changedByName == null ? pool.changedBy : pool.changedByName
                }
            } else {
                return {
                    id: pool.id,
                    poolId: pool.poolId,
                    displayPoolName: pool.newPoolName,
                    displayPoolDescription: pool.newPoolDescription,
                    displayAction: pool.action,
                    poolName: pool.poolName,
                    poolDescription: pool.poolDescription,
                    changedDate: pool.changedDate,
                    changedBy: pool.changedBy,
                    newPoolName: pool.newPoolName,
                    newPoolDescription: pool.newPoolDescription,
                    healthy: pool.healthy,
                    newHealthy: pool.newHealthy,
                    changedByName: pool.changedByName == null ? pool.changedBy : pool.changedByName
                }
            }
        })
    }

    const [rows, setRows] = useState(getPools());

    const requestSearch = (searchedVal, domain) => {
        setPage(0);
        const filteredRows = getPools().filter((row) => {
            if (domain === "displayPoolName") {
                if (row.displayPoolName !== null) return row.displayPoolName.toString().toLowerCase().includes(searchedVal.toLowerCase());
                else return null;
            }
            if (domain === "displayPoolDescription") {
                if (row.displayPoolDescription !== null) return row.displayPoolDescription.toString().toLowerCase().includes(searchedVal.toLowerCase());
                else return null;
            }
            if (domain === "displayAction") {
                if (row.displayAction !== null) return row.displayAction.toString().toLowerCase().includes(searchedVal.toLowerCase());
                else return null;
            }
            return getPools()
        });
        return setRows(filteredRows);
    };

    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched, "action"); // Domain set to anything will work here, without cancel will break as none of the request search options will be hit! 
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            handleSearch={requestSearch}
                            handleCancelSearch={cancelSearch}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    return (
                                        <CollapsedRows
                                            classes={classes}
                                            index={index}
                                            row={row}
                                        />
                                    );
                                })}
                            {(emptyRows > 0 && rows.length >= rowsPerPage) && (
                                <TableRow style={{ height: 80 * emptyRows }}>
                                    <TableCell colSpan={7} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
                    onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4 
                    onPageChange={handleChangePage} // Material v > 4
                    onChangePage={handleChangePage} // Material v < 4 
                />
            </Paper>
        </div>
    );
}

export default PoolAuditTable;
